import { Link } from "react-router-dom";

interface PaginationProps {
  current: number;
  total: number;
  basePath: string;
  query?: string;
}

export default function Pagination({ current, total, basePath, query = "" }: PaginationProps) {
  if (total <= 1) return null;

  const buildTo = (page: number) => `${basePath}${query}${query ? "&" : "?"}page=${page}`;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页导航">
      <Link
        to={buildTo(Math.max(1, current - 1))}
        aria-disabled={current === 1}
        className={`h-9 px-3 rounded-md border text-sm flex items-center gap-1 whitespace-nowrap transition-colors ${
          current === 1
            ? "border-background-200 text-foreground-300 pointer-events-none"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 cursor-pointer"
        }`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </Link>

      {pages.map((p) => (
        <Link
          key={p}
          to={buildTo(p)}
          className={`w-9 h-9 rounded-md border text-sm flex items-center justify-center whitespace-nowrap transition-colors ${
            p === current
              ? "bg-primary-500 border-primary-500 text-background-50 font-medium"
              : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          }`}
        >
          {p}
        </Link>
      ))}

      <Link
        to={buildTo(Math.min(total, current + 1))}
        aria-disabled={current === total}
        className={`h-9 px-3 rounded-md border text-sm flex items-center gap-1 whitespace-nowrap transition-colors ${
          current === total
            ? "border-background-200 text-foreground-300 pointer-events-none"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 cursor-pointer"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </Link>
    </nav>
  );
}